import { render } from "./Setting.vue?vue&type=template&id=cc52e986&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=cc52e986&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cc52e986"

export default script